module.exports = __webpack_public_path__ + "img/null.0ec9412b.svg";